import { ReactNode, useState } from "react";
import { Trash2 } from "lucide-react";
import { UUID } from "@bitory-gmbh/nidavellir";
import { toast } from "sonner";
import t from "@/lang/lang";
import { Dialog, DialogContent } from "@/shared/components/ui/dialog";
import {
  CommonDialogFooter,
  CommonDialogHeader,
  CommonDialogTrigger,
} from "@/shared/components/dialog/dialog-common";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useHtzSummaryDeleteMutation } from "@/services/backend/htz/summary/api/summary-api";

export function SummaryDeleteDialog({
  summaryId,
  trigger,
  onDeleted,
}: {
  summaryId: UUID;
  trigger?: ReactNode;
  onDeleted?: () => void;
}) {
  const [open, setOpen] = useState(false);
  const [deleteSummary, { isLoading, error, reset }] =
    useHtzSummaryDeleteMutation();

  const onConfirm = () => {
    if (isLoading) {
      return;
    }
    deleteSummary({ id: summaryId })
      .unwrap()
      .then(() => {
        toast.success(t("Inspektionsbericht gelöscht"));
        reset();
        setOpen(false);
        onDeleted?.();
      })
      .catch(() => {
        // error is surfaced via RTKQueryErrorAlert; swallow the rejection
      });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {trigger || (
        <CommonDialogTrigger icon={Trash2} label="" variant="destructive" />
      )}
      <DialogContent>
        <CommonDialogHeader
          title={t("Inspektionsbericht wirklich löschen?")}
          description={t(
            "Der Inspektionsbericht und seine Übersicht der Anlagenberichte werden gelöscht. Die Anlagenberichte selbst bleiben erhalten.",
          )}
        />
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter
          isLoading={isLoading}
          onClickAction={onConfirm}
          actionLabel={t("Löschen")}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
